module.exports = __webpack_public_path__ + "static/media/pan_cover_campanha_whatsapp.06887c4b.png";